const RETRY_PARAM = '__asset_retry';

// Only loading failures can be repaired by refreshing a stale deployment.
// Keep the marker in the URL so blocked storage cannot cause a reload loop.
export const getChunkRecoveryUrl = (error: unknown, currentUrl: string, release: string): string | null => {
  const message = error instanceof Error ? error.message : String(error);
  if (!/valid JavaScript MIME type|Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS/i.test(message)) {
    return null;
  }

  const url = new URL(currentUrl);
  if (url.searchParams.get(RETRY_PARAM) === release) return null;
  url.searchParams.set(RETRY_PARAM, release);
  return url.href;
};
